import React, { useState } from "react";
import { Field, reduxForm } from "redux-form";
import { Button } from "@material-ui/core";
import PropTypes from "prop-types";
import "./CommentForm.scss";
import InputTextField from "./InputTextField";

import _ from "lodash";

let disableSubmit = true;

const MAX_COMMENT_LENGTH = 1000;

const validateCommentName = (values) => {
  if (!values.comment_name) {
    return "Comment name required";
  }
  const withoutLeadingSpaces = values.comment_name.replace(/^\s+/g, "");
  if (values.comment_name.length > 40) {
    return "Comment name exceeds 40 characters";
  }
  if (withoutLeadingSpaces === "") {
    return "Comment name contains only whitespaces";
  }
  return null;
};

const validateCategoryCommentText = (values) => {
  if (!values.comment_text) {
    return "Comment text required";
  }
  const withoutLeadingSpacesText = values.comment_text.replace(/^\s+/g, "");
  if (values.comment_text.length > MAX_COMMENT_LENGTH) {
    return `Comment text exceeds ${MAX_COMMENT_LENGTH} characters`;
  }
  if (withoutLeadingSpacesText === "") {
    return "Comment text contains only whitespaces";
  }
  return null;
};

const validateProjectCommentText = (values) => {
  if (!values.comment_txt) {
    return "Comment text required";
  }
  const withoutLeadingSpacesText = values.comment_txt.replace(/^\s+/g, "");
  if (values.comment_txt.length > MAX_COMMENT_LENGTH) {
    return `Comment text exceeds ${MAX_COMMENT_LENGTH} characters`;
  }
  if (withoutLeadingSpacesText === "") {
    return "Comment text contains only whitespaces";
  }
  return null;
};

const updateDisableSubmitState = (errors) => {
  disableSubmit = !_.isEmpty(errors);
};

const validate = (values, props) => {
  const errors = {};
  const { isProjectLevel } = props;

  const nameError = validateCommentName(values);
  if (nameError) {
    errors.comment_name = nameError;
  }

  if (isProjectLevel) {
    const textError = validateProjectCommentText(values);
    if (textError) {
      errors.comment_txt = textError;
    }
  } else {
    const textError = validateCategoryCommentText(values);
    if (textError) {
      errors.comment_text = textError;
    }
  }

  updateDisableSubmitState(errors);
  return errors;
};

const renderTextField = ({ meta: { touched, error }, input, ...custom }) => (
  <div>
    <InputTextField {...input} {...custom} />
    {touched && error && (
      <font
        color='#f44336'
        fontFamily='Arial'
        fontSize='0.75rem'
        margin-left='10px'>
        {error}
      </font>
    )}
  </div>
);

export const SubCategoryCommentForm = props => {
  const { handleSubmit, onCancel, id, isProjectLevel } = props;
  const [commentTextLength, setCommentTextLength] = useState(0);

  function submit(e) {
    e.preventDefault();
    handleSubmit(id);
    onCancel(id);
    return false;
  }

  return (
    <form onSubmit={submit}>
      <div className="comment-name">
        <Field
          inputType='text'
          inputDefaultValue=''
          showInputAdornment={false}
          component={renderTextField}
          name='comment_name'
          placeholder='Comment Name'
        />
      </div>
      <div className='comment-main'>
        <Field
          className='comment-input'
          name={isProjectLevel ? "comment_txt" : "comment_text"}
          component={renderTextField}
          rows='8'
          multiline
          variant='outlined'
          placeholder='Comment Message'
          onChange={(e) => setCommentTextLength(e.target.value.length)}
        />
        <div className='char-counter'>
          {Math.max(0, MAX_COMMENT_LENGTH - commentTextLength)} characters remaining
        </div>
      </div>
      <div className='buttons'>
        <Button
          className='cancel-button'
          type='button'
          onClick={() => onCancel(id)}>
          Cancel
        </Button>
        <Button
          disabled={disableSubmit}
          className='submit-button'
          type='submit'>
          Submit
        </Button>
      </div>
    </form>
  );
};

renderTextField.defaultProps = {
  input: "",
};

renderTextField.propTypes = {
  input: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string,
  }),
};

SubCategoryCommentForm.defaultProps = {
  reply: false,
};

SubCategoryCommentForm.propTypes = {
  reply: PropTypes.bool,
  handleSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  id: PropTypes.number,
  isProjectLevel: PropTypes.bool.isRequired,
};

export default reduxForm({
  form: "subCategoryCommentForm",
  keepDirtyOnReinitialize: true,
  enableReinitialize: true,
  validate,
})(SubCategoryCommentForm);
